import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import BigBox from '../BigBox.js';
import OtherService from '../../services/Other';
import ChartNew from '../ChartNew.js';
import DealerGraph from './DealerGraph.js';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const TseContractorOverview = () => {
  const brandId = JSON.parse(localStorage.getItem("currentBrand")).id;
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [],
  });
  const [loading, setLoading] = useState(false);

  const hierdesc = JSON.parse(localStorage.getItem("userData")).hierCode;
  

  useEffect(() => {
    getTseUserPerTierData();
  }, [brandId]);

  const getTseUserPerTierData = async () => {
    setLoading(true);
    try {
      const res = await OtherService.getTsePieData();
      if (res.success === true) {
        const result = res?.response?.user_count || [];
        const labels = result.map((el) => el.tier_name);
        const data = result.map((el) => el.user_count);
        const backgroundColors = result.map((el) => el.color);
        const formattedChartData = {
          labels,
          datasets: [
            {
              label: "User Count",
              data,
              backgroundColor: backgroundColors,
              borderWidth: 1,
            },
          ],
        };
        setChartData(formattedChartData);
      }
    } catch (error) {
      console.error("pie chart api error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-100">
      <div header={"Tier Bifurcation"}>
        <BigBox header={"Tier Bifurcation"}></BigBox>
        <div style={{ width: "100%" }}>
          {loading ? (
            <p>Loading chart...</p>
          ) : chartData.labels.length > 0 ? (
            <ChartNew chartData={chartData} />
          ) : (
            <p>No data available</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default TseContractorOverview;
